<!--
 * @Author: andy_chen
 * @created: 2018-10-31 15:57:46
 * 编辑昵称
-->

<template>
    <div class="container">
        <div class="form-item">
            <label>
                <input type="text" class="form-item-input" v-model="nickname" placeholder="请输入昵称">
            </label>
        </div>
        <p class="form-tip">15个字符内，可由汉字、字母、数字和下划线_组成</p>
        <div v-if="!$env.isTravelCatApp" class="cat-btn medium submit-btn" @click="handleSubmit">保存</div>
    </div>
</template>

<script>
import { postEdit } from "../api/user.js";
import Form from "../utils/form.js";
import nativeApi from "../nativeApi/index.js";

export default {
    name: "EditNickname",
    components: {},

    created() {
        // 拿到上一个页面传过来的昵称
        this.nickname = this.$route.query.nickname || "";

        if (this.$env.isTravelCatApp) {
            nativeApi.setRightBtn({ text: "完成" });
            nativeApi.onRightBtnClick(() => {
                this.handleSubmit();
            });
        }
    },

    data() {
        return {
            nickname: ""
        };
    },
    mounted() {
        this.initForm();
    },

    methods: {
        /**
         * 检查长度
         */
        checkLength(value = "") {
            return value.length <= 15;
        },

        /**
         * 初始化表单验证规则
         */
        initForm() {
            this.myForm = new Form({
                nickname: [
                    { validate: Form.required, msg: "请输入昵称" },
                    { validate: this.checkLength, msg: "昵称应在15字内" },
                    {
                        validate: Form.legalText,
                        msg: "昵称仅支持汉字、字母、数字和下划线_"
                    }
                ]
            });
        },

        /**
         * 提交昵称修改
         */
        handleSubmit() {
            // 验证表单
            this.nickname = this.nickname.trim();
            let result = this.myForm.validateByName("nickname", this.nickname);

            if (result.validate) {
                let data = { nickname: this.nickname };

                this.$loading.open();
                postEdit(data)
                    .then(res => {
                        if (+res.code === 200) {
                            // 使用对象
                            this.$toast.open({ msg: "保存成功" });
                            setTimeout(() => {
                                this.$env.isTravelCatApp
                                    ? nativeApi.goBack()
                                    : this.$router.go(-1);
                            }, 1000);
                        } else {
                            this.$toast.open({ msg: res.msg });
                        }
                    })
                    .finally(() => {
                        this.$loading.close();
                    });
            } else {
                this.$toast.open({ msg: result.msg });
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

.container {
    background: $baseBackgroundColor;
    padding-top: 0.2rem;
}

.form-item {
    background: #fff;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.3rem;

    > label {
        width: 100%;
        height: 100%;
        display: block;
    }

    .form-item-input {
        border: none;
        outline: none;
        width: 100%;
        height: 0.6rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
    }
}

.form-tip {
    padding: 0.3rem 0.3rem 0 0.3rem;
    color: $secondaryColor;
    font-size: 0.24rem;
}

.submit-btn {
    width: 7.1rem;
    margin: 0.6rem auto 0;
}
</style>
